import React from 'react';
import { Calendar, Users, MessageSquare, Bell, Heart, Share2, Eye } from 'lucide-react';
import type { WidgetProps } from '../../../types/dashboard';

const activities = [
  {
    icon: Calendar,
    text: 'New post scheduled for tomorrow',
    time: '2 hours ago',
    color: 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400',
  },
  {
    icon: Users,
    text: 'Gained 50 new followers',
    time: '4 hours ago',
    color: 'bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400',
  },
  {
    icon: MessageSquare,
    text: 'New comment on your latest post',
    time: '5 hours ago',
    color: 'bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400',
  },
  {
    icon: Bell,
    text: 'Content performance alert',
    time: '6 hours ago',
    color: 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400',
  },
  {
    icon: Heart,
    text: 'Your post received 120 likes',
    time: '8 hours ago',
    color: 'bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400',
  },
  {
    icon: Share2,
    text: 'Your post was shared 15 times',
    time: '10 hours ago',
    color: 'bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400',
  },
  {
    icon: Eye,
    text: 'Your profile was viewed 45 times',
    time: '12 hours ago',
    color: 'bg-teal-50 dark:bg-teal-900/20 text-teal-600 dark:text-teal-400',
  }
];

export const ActivityWidget: React.FC<WidgetProps> = () => {
  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center space-x-2">
          <div className="p-2 bg-indigo-50 dark:bg-indigo-900/20 rounded-md">
            <Bell className="h-4 w-4 text-indigo-600 dark:text-indigo-400" />
          </div>
          <div className="text-sm font-medium text-gray-900 dark:text-white">Recent Activity</div>
        </div>
        <button className="text-xs text-indigo-600 dark:text-indigo-400 hover:underline">View all</button>
      </div>
      
      <div className="flex-1 overflow-auto pr-2 space-y-3 no-scrollbar">
        {activities.map((activity, index) => {
          const Icon = activity.icon;
          return (
            <div 
              key={index} 
              className="flex items-start space-x-4 p-4 bg-white dark:bg-dark-800 border border-gray-100 dark:border-dark-700 rounded-xl hover:shadow-sm transition-all duration-200"
            >
              <div className={`p-2.5 rounded-lg ${activity.color}`}>
                <Icon className="h-4 w-4" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-800 dark:text-gray-200">{activity.text}</p>
                <p className="text-xs text-gray-400 dark:text-gray-500 mt-1.5">{activity.time}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};